import React, { Component } from "react";
import "./UpImage.css";
import { Icon, message, Modal } from "antd";
import { Prompt } from "react-router-dom";
import { API_URL } from "../../_config";
import CarFileList from "./CarFileList";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { DndProvider } from "react-dnd";
import { store } from "../../_helpers";
import axios from "axios";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { Row, Col, Button } from "shards-react";

const cookies = new Cookies();

/** Construye headers EXACTOS según X-Amz-SignedHeaders de la URL presignada */
function buildS3Headers(presign, file) {
  const signed = (presign.signed_headers || "")
    .toLowerCase()
    .split(";")
    .filter(Boolean);

  const h = new Headers();
  if (signed.includes("x-amz-server-side-encryption")) {
    h.set("x-amz-server-side-encryption", "AES256");
  }
  if (signed.includes("content-disposition")) {
    h.set("Content-Disposition", "inline");
  }
  if (signed.includes("content-type")) {
    h.set("Content-Type", file.type);
  }
  if (signed.includes("x-amz-acl")) {
    const m = presign.url && presign.url.match(/[?&]x-amz-acl=([^&]+)/i);
    if (m) h.set("x-amz-acl", decodeURIComponent(m[1]));
  }
  return h;
}

/** util para reordenar sin mutar */
function reorder(list, from, to) {
  const arr = Array.isArray(list) ? [...list] : [];
  if (from === to || from < 0 || to < 0 || from >= arr.length || to >= arr.length) {
    return arr;
  }
  const [drag] = arr.splice(from, 1);
  arr.splice(to, 0, drag);
  return arr;
}

class UpImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hightlight: false,
      updated: false,
      reflejar: false,
      listFiles: [],
      previewImage: "",
      previewVisible: false,
    };
    this.fileInputRef = React.createRef();
    // Map de imageId -> AbortController para cancelar requests en vuelo
    this._abortControllers = new Map();
  }

  componentDidMount() {
    this._mounted = true;
    this.setState({
      listFiles: Array.isArray(this.props.filelist) ? this.props.filelist : [],
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const hadPending = (prevState.listFiles || []).some((img) => img.state === "deleting");
    const hasPending = this.hasPendingDeletes();

    if (!hadPending && hasPending) {
      window.addEventListener("beforeunload", this.handleBeforeUnload);
      // Avisar al padre que hay deletes en curso → deshabilita Guardar
      this.props.onPendingChange && this.props.onPendingChange(true);
    } else if (hadPending && !hasPending) {
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
      // Avisar al padre que ya no hay deletes pendientes
      this.props.onPendingChange && this.props.onPendingChange(false);
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    // Cancelar todas las requests en vuelo
    this._abortControllers.forEach((controller) => controller.abort());
    this._abortControllers.clear();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  // Evita cierre/refresh del browser mientras hay deletes corriendo
  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = ""; // requerido por Chrome
  };

  hasPendingDeletes = () =>
    (this.state.listFiles || []).some((img) => img.state === "deleting");

  openFileDialog = () => {
    if (this.props.disabled) return;
    if (this.fileInputRef.current) this.fileInputRef.current.click();
  };

  handlePreview = (index) => {
    const img = (this.state.listFiles || [])[index];
    if (!img) return;
    this.setState({ previewImage: img.url, previewVisible: true });
  };

  handleCancel = () => this.setState({ previewVisible: false });

  onFilesAdded = (evt) => {
    if (this.props.disabled) return;
    const files = evt.target.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    if (this.fileInputRef.current) this.fileInputRef.current.value = "";
  };

  onDragOver = (evt) => {
    evt.preventDefault();
    if (this.props.disabled) return;
    this.setState({ hightlight: true });
  };

  onDragLeave = () => this.setState({ hightlight: false });

  onDrop = (event) => {
    event.preventDefault();
    if (this.props.disabled) return;
    const files = event.dataTransfer.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    this.setState({ hightlight: false });
  };

  fileListToArray(list) {
    const array = [];
    for (let i = 0; i < list.length; i++) {
      const file = list.item(i);
      if (!file) continue;
      const hash = this.stringToHash(file.name);
      const cnt = { hash, id: hash, image_order: 1, url: file, state: "load" };
      this.setState((state) => ({ listFiles: [...state.listFiles, cnt] }));
      this.subir(file, hash);
      array.push(file);
    }
    return array;
  }

  stringToHash($string) {
    const string = $string + Date.now();
    let hash = 0;
    if (string.length === 0) return hash;
    for (let i = 0; i < string.length; i++) {
      let char = string.charCodeAt(i);
      hash = (hash << 15) - hash + char;
      hash = hash & hash;
    }
    return hash;
  }

  subir = async (file, hash) => {
    try {
      const isImage = /image\/(jpeg|jpg|png|webp)/i.test(file.type);
      if (!isImage) {
        message.error("Formato inválido. Solo .JPG, .PNG o .WEBP");
        return;
      }

      const hide = message.loading("Subiendo imagen...", 0);

      const dealerId = cookies.get("dealer").id;
      const token = store.getState().authentication.user.token;

      // 1) presign
      const presResp = await axios.get(`${API_URL}api/s3/presign`, {
        params: {
          dealer_id: dealerId,
          vehicle_id: this.props.id_vehicle,
          filename: file.name,
          contentType: file.type,
          token,
        },
      });
      const presign = presResp.data;

      // 2) headers EXACTOS
      const headers = buildS3Headers(presign, file);

      // 3) PUT con fetch
      const putRes = await fetch(presign.url, { method: "PUT", headers, body: file });
      if (!putRes.ok) {
        const txt = await putRes.text();
        throw new Error(`S3 PUT ${putRes.status}: ${txt}`);
      }

      // 4) fix metadata si es necesario
      if (!String(presign.signed_headers || "").toLowerCase().includes("content-type")) {
        try {
          await axios.post(
            `${API_URL}api/s3/fix-metadata`,
            { key: presign.key, contentType: file.type },
            { params: { token } }
          );
        } catch (_) {}
      }

      // 5) registrar URL en la API
      await this.onUpdateItem(presign.public_url, hash);

      hide();
      message.success("Imagen subida correctamente");
    } catch (err) {
      message.error("No se pudo subir la imagen. Intente nuevamente.");
      this.setState(({ listFiles }) => ({
        listFiles: (listFiles || []).map((it) =>
          it.hash === hash ? { ...it, state: "error" } : it
        ),
      }));
    }
  };

  onUpdateItem = async (i, hash) => {
    try {
      const token = store.getState().authentication.user.token;
      const dealerId = cookies.get("dealer").id;

      const response = await axios.post(
        `${API_URL}api/dealer/${dealerId}/vehicle/${this.props.id_vehicle}/image/link`,
        { url: i, id: true },
        { params: { token } }
      );

      if (
        this.props.prop &&
        this.props.prop.initialValues &&
        this.props.prop.initialValues.publish &&
        (this.props.prop.initialValues.publish.olx === true ||
          this.props.prop.initialValues.publish.deMotores === true ||
          this.props.prop.initialValues.publish.autoCosmos === true ||
          this.props.prop.initialValues.publish.mercadolibre === true)
      ) {
        this.setState({ reflejar: true });
      }

      this.setState(({ listFiles }) => ({
        listFiles: (listFiles || []).map((item) =>
          item.hash === hash
            ? { hash, id: response.data.id, url: i, state: "done" }
            : item
        ),
      }));
    } catch (_) {
      message.error("No se pudo registrar la imagen. Intente más tarde.");
    }
  };

  /** Verifica si el vehículo está publicado en algún portal */
  isPublished = () => {
    const publish =
      this.props.prop &&
      this.props.prop.initialValues &&
      this.props.prop.initialValues.publish;
    return (
      publish &&
      (publish.olx === true ||
        publish.deMotores === true ||
        publish.autoCosmos === true ||
        publish.mercadolibre === true)
    );
  };

  /**
   * Elimina una imagen de forma optimista:
   * 1. Marca como "deleting" en el estado → UI responde de inmediato
   * 2. Llama al DELETE en background
   * 3. Si falla → revierte a "done" + muestra error
   */
  removeItem = (index, imageId) => {
    // Guard: si ya está siendo eliminada, ignorar el click
    const alreadyDeleting = (this.state.listFiles || []).some(
      (img) => img.id === imageId && img.state === "deleting"
    );
    if (alreadyDeleting) return;

    // Marcar como deleting inmediatamente
    this.setState(({ listFiles }) => ({
      listFiles: listFiles.map((item) =>
        item.id === imageId ? { ...item, state: "deleting" } : item
      ),
    }));

    const token = store.getState().authentication.user.token;
    const dealerId = cookies.get("dealer").id;
    const controller = new AbortController();
    this._abortControllers.set(imageId, controller);

    axios
      .delete(`${API_URL}api/dealer/${dealerId}/vehicles/image/${imageId}`, {
        params: { token },
        signal: controller.signal,
      })
      .then(() => {
        this._abortControllers.delete(imageId);
        this.setState(({ listFiles }) => ({
          listFiles: listFiles.filter((i) => i.id !== imageId),
        }));
        if (this.isPublished()) {
          this.setState({ reflejar: true });
        }
      })
      .catch((err) => {
        this._abortControllers.delete(imageId);
        // Si fue cancelado por navegación no mostramos error
        if (axios.isCancel(err)) return;
        this.setState(({ listFiles }) => ({
          listFiles: listFiles.map((item) =>
            item.id === imageId ? { ...item, state: "done" } : item
          ),
        }));
        message.error("No se pudo eliminar la imagen. Intente nuevamente.");
      });
  };

  /**
   * Elimina todas las imágenes:
   * 1. Guarda la lista actual por si hay que revertir
   * 2. Vacía la UI de inmediato
   * 3. Llama DELETE en paralelo para todas
   * 4. Si alguna falla → vuelve a mostrar solo las fallidas
   */
  removeAll = () => {
    const imagesToDelete = (this.state.listFiles || []).filter(
      (img) => img.state === "done" || img.state === undefined
    );
    if (imagesToDelete.length === 0) return;

    const token = store.getState().authentication.user.token;
    const dealerId = cookies.get("dealer").id;

    // Marcar todas como "deleting" → activa beforeunload, muestra spinners
    this.setState(({ listFiles }) => ({
      listFiles: listFiles.map((img) =>
        imagesToDelete.some((d) => d.id === img.id)
          ? { ...img, state: "deleting" }
          : img
      ),
    }));

    Promise.allSettled(
      imagesToDelete.map((img) => {
        const controller = new AbortController();
        this._abortControllers.set(img.id, controller);
        return axios
          .delete(`${API_URL}api/dealer/${dealerId}/vehicles/image/${img.id}`, {
            params: { token },
            signal: controller.signal,
          })
          .finally(() => this._abortControllers.delete(img.id));
      })
    ).then((results) => {
      if (!this._mounted) return;

      const failed = imagesToDelete.filter((_, i) => results[i].status === "rejected");
      const succeeded = imagesToDelete.filter((_, i) => results[i].status === "fulfilled");

      // Sacar las exitosas, revertir las fallidas a "done"
      this.setState(({ listFiles }) => ({
        listFiles: listFiles
          .filter((img) => !succeeded.some((s) => s.id === img.id))
          .map((img) =>
            failed.some((f) => f.id === img.id) ? { ...img, state: "done" } : img
          ),
      }));

      if (failed.length > 0) {
        message.error(
          `No se pudieron eliminar ${failed.length} imagen${failed.length > 1 ? "es" : ""}. Intente nuevamente.`
        );
      } else if (this.isPublished()) {
        this.setState({ reflejar: true });
      }
    });
  };

  reflejar = () => {
    this.props.enviarData && this.props.enviarData();
    this.setState({ reflejar: false });
  };

  confirm_order = () => {
    const newItem = (this.state.listFiles || []).map((j) => j.id);
    const token = store.getState().authentication.user.token;
    const dealerId = cookies.get("dealer").id;

    axios
      .post(
        `${API_URL}api/dealer/${dealerId}/vehicle/${this.props.id_vehicle}/order-images`,
        { newItem },
        { params: { token } }
      )
      .then(() => {
        this.props.enviarData && this.props.enviarData();
        this.setState({ updated: false });
      })
      .catch(() => {
        message.error("Ocurrió un error al guardar el orden.");
      });
  };

  moveImage = (dragIndex, hoverIndex) => {
    this.setState((prev) => ({
      listFiles: reorder(prev.listFiles, dragIndex, hoverIndex),
      updated: true,
    }));
  };

  render() {
    // Calculado una sola vez por instancia, no en cada render
    if (!this._dndBackend) {
      this._dndBackend = "ontouchstart" in window ? TouchBackend : HTML5Backend;
    }
    const { listFiles } = this.state;
    const deletableCount = (listFiles || []).filter(
      (img) => img.state === "done" || img.state === undefined
    ).length;

    return (
      <div className="clearfix content-inputCustomFile container-fluid">
        {/* Bloquea navegación interna (react-router) mientras hay deletes corriendo */}
        <Prompt
          when={this.hasPendingDeletes()}
          message="Hay imágenes eliminándose, esperá que termine el proceso antes de salir."
        />
        <div className="row">
          <div
            className={`inputCustomFile ${this.state.hightlight ? "Highlight" : ""}`}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            onDrop={this.onDrop}
            onClick={this.openFileDialog}
            style={{ cursor: this.props.disabled ? "default" : "pointer" }}
          >
            <input
              ref={this.fileInputRef}
              className="FileInput"
              type="file"
              multiple
              onChange={this.onFilesAdded}
            />
            <span>Subir imagenes — Haga clic o arrastre sus imágenes a esta área</span>
          </div>

          <div className="left ant-upload-list ant-upload-list-picture-card">
            <DndProvider backend={this._dndBackend}>
              {listFiles && listFiles.length > 0 && (
                <CarFileList
                  images={listFiles}
                  remove={this.removeItem}
                  moveImage={this.moveImage}
                  preview={this.handlePreview}
                />
              )}
            </DndProvider>
          </div>
        </div>

        {/* Acciones de orden y eliminación masiva */}
        {listFiles && listFiles.length > 0 && (
          <Row className="mt-3">
            {this.state.updated && (
              <Col sm={3}>
                <Button onClick={this.confirm_order} className="w-100">
                  Confirmar orden
                </Button>
              </Col>
            )}
            {this.state.updated && (
              <Col sm={6}>
                <p className="mb-0 mt-2">
                  Debe confirmar el orden para que los cambios queden guardados.
                </p>
              </Col>
            )}
            {deletableCount > 1 && (
              <Col sm={3} className="ml-auto">
                <Button
                  theme="danger"
                  outline
                  className="w-100"
                  onClick={this.removeAll}
                >
                  <Icon type="delete" /> Eliminar todas ({deletableCount})
                </Button>
              </Col>
            )}
          </Row>
        )}

        {/* Banner reflejar cambios */}
        {this.state.reflejar && (
          <Row className="mt-3">
            <Col sm={3}>
              <Button onClick={this.reflejar} className="w-100">
                Reflejar cambios
              </Button>
            </Col>
            <Col sm={9}>
              <p className="mb-0">
                Los cambios se guardaron en la base de datos. Presioná{" "}
                <strong>Reflejar</strong> para actualizarlos en los portales publicados.
              </p>
            </Col>
          </Row>
        )}

        <Modal
          visible={this.state.previewVisible}
          title={null}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="preview" style={{ width: "100%" }} src={this.state.previewImage} />
        </Modal>
      </div>
    );
  }
}

export default connect()(UpImage);
